import React, { useEffect, useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const WHATSAPP_PHONE = '254701660306';
const WHATSAPP_MSG = encodeURIComponent("Hi Belo Digital, I'd like to chat about a project.");
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_PHONE}?text=${WHATSAPP_MSG}`;
const RADIUS = 30;
const STROKE = 3;
const SIZE = (RADIUS + STROKE) * 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
export function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? scrollTop / docHeight : 0);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const offset = CIRCUMFERENCE * (1 - progress);
  return <div className="fixed bottom-6 right-6 z-50" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} data-id="element-739">
      <div className="relative flex items-center justify-center" style={{
      width: SIZE,
      height: SIZE
    }} data-id="element-740">
        {/* Scroll progress ring — sits behind the button */}
        <svg width={SIZE} height={SIZE} className="absolute inset-0 pointer-events-none" style={{
        transform: 'rotate(-90deg)'
      }} data-id="element-741">
          {/* Track */}
          <circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth={STROKE} data-id="element-742" />
          {/* Progress arc */}
          <circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" stroke="#FF6600" strokeWidth={STROKE} strokeLinecap="round" strokeDasharray={CIRCUMFERENCE} strokeDashoffset={offset} style={{
          transition: 'stroke-dashoffset 0.1s linear'
        }} data-id="element-743" />
        </svg>

        {/* Ping ring */}
        <span className="absolute w-14 h-14 rounded-full bg-[#25D366] opacity-30 animate-ping" data-id="element-744" />

        {/* WhatsApp button */}
        <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Chat with us on WhatsApp" initial={{
        scale: 0,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 1,
        type: 'spring',
        stiffness: 260,
        damping: 20
      }} whileHover={{
        scale: 1.08
      }} whileTap={{
        scale: 0.93
      }} className="relative w-14 h-14 rounded-full shadow-lg flex items-center justify-center z-10" style={{
        backgroundColor: '#25D366'
      }} data-id="element-745">
          <AnimatePresence data-id="element-746">
            {hovered && <motion.span initial={{
            opacity: 0,
            x: 10
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: 10
          }} transition={{
            duration: 0.2
          }} className="absolute right-16 bg-white text-[#0C0C0C] text-sm font-medium px-3 py-2 rounded-lg shadow-md whitespace-nowrap" data-id="element-747">
                Chat with us
              </motion.span>}
          </AnimatePresence>

          <motion.svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-7 h-7" animate={{
          y: [0, -2, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2.5,
          ease: 'easeInOut',
          delay: 2
        }} data-id="element-748">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-749" />
          </motion.svg>
        </motion.a>
      </div>
    </div>;
}